import _ from 'lodash';
import Typography from "@mui/material/Typography";
import {parseGutenbergReact, parseParagraphReact} from "@/api/global";
import NoSidebarLayout from "../PageLayouts/NoSidebarLayout";
import Breadcrumbs from "@/components/01_atoms/Breadcrumbs";

let layoutOpts = {
  titleBgWide: false,
  titleBgClr: "warning.dark",
  mainBgClr: "",
  // mainBgImg: '/images/bg-c-n-page.jpg',
  sideBgClr: false,
  topBgClr: false,
};

const DefaultNode = (props) => {
  let {node, opts, children} = props;
  layoutOpts = opts ? {...layoutOpts, opts} : layoutOpts;
  if (node?.bgSlider?.length > 0) {
    layoutOpts.topBgClr = node.bgSlider;
  }

  let {
    title,
    hideTitle,
    summary,
    body,
    body_json,
    para,
    paraTop,
    slides,
  } = node;

  const topbar = (
    <>
      {paraTop?.length > 0 &&
        <Typography paragraph component={`div`} className={`region-top`}>
          {
            paraTop.map((para_ent, key) => {
              return parseParagraphReact(key, para_ent, slides);
            })
          }
        </Typography>
      }
      {Array.isArray(node?.breadcrumbs) && node?.breadcrumbs?.length > 0 &&
      <Breadcrumbs links={node.breadcrumbs} />
      }
    </>
  );

  return (
    <NoSidebarLayout title={title} hideTitle={hideTitle} summary={summary} top_region={topbar} opts={layoutOpts}>
      <>
        {(body_json?.json?.length > 0) &&
          body_json.json.map((block, key) => {
            return parseGutenbergReact(key, block);
          })
        }
        {body?.length > 0 && _.isEmpty(body_json) &&
          <Typography paragraph component={`div`}>
            <div dangerouslySetInnerHTML={{__html: body}}></div>
          </Typography>
        }
        {para?.length > 0 &&
          <Typography paragraph component={`div`}>
            {
              para.map((para_ent, key) => {
                return parseParagraphReact(key, para_ent, slides);
              })
            }
          </Typography>
        }
        {children}
      </>

    </NoSidebarLayout>
  );
};

export default DefaultNode;
